<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { ColumnHeightOutlined } from '@ant-design/icons-vue';
import {
  Popover, Button, RadioGroup, Radio, Tooltip,
} from 'ant-design-vue';

import useConfig from '@/providers/config/useConfig';

export default defineComponent({
  name: 'TableSizeSelect',
  components: {
    Popover,
    Tooltip,
    Button,
    ColumnHeightOutlined,
    RadioGroup,
    Radio,
  },
  setup() {
    const { setDensity, config: { tableDensity } } = useConfig();
    const value = ref(tableDensity);
    watch(value, () => setDensity(value.value));
    return {
      visible: ref(false),
      value,
      setDensity,
      tableDensity,
    };
  },
});
</script>
<template>
  <Popover v-model:open="visible" placement="bottomLeft" trigger="click">
    <Tooltip title="Density Table">
      <Button size="small" @click.prevent>
        <ColumnHeightOutlined />
      </Button>
    </Tooltip>
    <template #content>
      <RadioGroup v-model:value="value">
        <div class=" mb-1">
          <Radio value="large">
            Larger
          </Radio>
        </div>
        <div class=" mb-1">
          <Radio value="middle">
            Middle
          </Radio>
        </div>
        <div>
          <Radio value="small">
            Compact
          </Radio>
        </div>
      </RadioGroup>
    </template>
  </Popover>
</template>
